import styled from 'styled-components';

import { Button } from '@design-system-coopeuch/web';

export const StyledButton = styled(Button)`
  /* border: solid 2px black !important; */
  ${(props) =>
    props.appearanceDisabled
      ? `
      background-color: #d4d4d4 !important;
      color: white;
      &:hover {
        background-color: #d4d4d4 !important;
        color: white;
        cursor: default;
        box-shadow: 0 2px 4px 0 rgb(30 30 30 / 35%);
      }
  `
      : ''};
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
  }
`;

export const StyledWrapperButtons = styled.section`
  display: flex;
  /* justify-content: flex-start; */
  flex-direction: row;
  flex-wrap: wrap;
  @media screen and (min-width: 768px) {
    flex-direction: row-reverse;
    justify-content: space-between;
  }
`;
